export default __webpack_public_path__ + "media/images/down-arrow-07dc223ebed5e4a6e037ef3042f2507e.svg";